export type MeasuringEquipmentTableHeader = {
    xmlId: string;
    visibility: boolean;
    columns: MeasuringEquipmentHeaderColumn[];
};

export type MeasuringEquipmentHeaderColumn = {
    xmlId: string; // mapping from the thead>tr>th><p> id
    columnName: string;
};

export type MeasuringEquipmentTableRow = {
    rowId: string;
    visibility: boolean;
    columns: MeasuringEquipmentRowColumn[];
};

export type MeasuringEquipmentRowColumn = {
    label: string;
    columnId: string; // mapping from the tbody>tr>td>input id
    columnName: string;
    value: string;
};

export type MeasuringEquipments = {
    header: MeasuringEquipmentTableHeader;
    rows: MeasuringEquipmentTableRow[];
    visibility: boolean;
    heading: string;
    xmlId: string;
    canSubmitForm: boolean;
    noMeasurementToolsUsed: boolean;
};

export enum MeasuringEquipmentsControlName {
    Description = 'Description',
    EquipmentId = 'Equipment ID',
    Calibrated = 'Calibrated until/Status',
    DateUsed = 'Date used',
}

export const initialMeasuringEquipments: MeasuringEquipments = {
    header: {
        xmlId: '',
        visibility: false,
        columns: [],
    },
    rows: [],
    visibility: false,
    heading: '',
    xmlId: '',
    canSubmitForm: false,
    noMeasurementToolsUsed: false,
};
